module.exports = argument => {
    throw argument;
};
